import { getKeycloak } from './keycloak-instance';

/**
 * Desloga o admin e volta pra tela inicial. Roteia pelo end-session do Keycloak
 * (limpa o `KEYCLOAK_SESSION` server-side e derruba o access token em memória) —
 * apenas limpar estado local NÃO deslogaria (o próximo check-sso re-autenticaria
 * da sessão SSO ainda válida). Fonte única de "sair" no admin SPA.
 */
export function logoutToLogin(): void {
  getKeycloak().logout({ redirectUri: `${window.location.origin}/` });
}
